// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-flagIcon::before{background:url(\"//cdn.finnair.com/fcom-booking-widget/7.3.0/images/flags-sprite.png\") no-repeat;background-size:24px 1667px;content:\"\";display:inline-block;height:18px;vertical-align:text-top;width:24px}.bw-flag_au::before{background-position:0 0}.bw-flag_at::before{background-position:0 -22px}.bw-flag_be::before{background-position:0 -45px}.bw-flag_ca::before{background-position:0 -67px}.bw-flag_cn::before{background-position:0 -90px}.bw-flag_hr::before{background-position:0 -112px}.bw-flag_cz::before{background-position:0 -135px}.bw-flag_dk::before{background-position:0 -157px}.bw-flag_ee::before{background-position:0 -180px}.bw-flag_fi::before{background-position:0 -202px}.bw-flag_fr::before{background-position:0 -225px}.bw-flag_de::before{background-position:0 -247px}.bw-flag_int::before{background-position:-3px -270px}.bw-flag_hk::before{background-position:0 -292px}.bw-flag_hu::before{background-position:0 -315px}.bw-flag_in::before{background-position:0 -337px}.bw-flag_il::before{background-position:0 -360px}.bw-flag_it::before{background-position:0 -382px}.bw-flag_jp::before{background-position:0 -405px}.bw-flag_kr::before{background-position:0 -630px}.bw-flag_lv::before{background-position:0 -427px}.bw-flag_lt::before{background-position:0 -450px}.bw-flag_nl::before{background-position:0 -472px}.bw-flag_no::before{background-position:0 -495px}.bw-flag_pl::before{background-position:0 -517px}.bw-flag_pt::before{background-position:0 -540px}.bw-flag_ru::before{background-position:0 -562px}.bw-flag_sg::before{background-position:0 -585px}.bw-flag_si::before{background-position:0 -607px}.bw-flag_es::before{background-position:0 -652px}.bw-flag_se::before{background-position:0 -675px}.bw-flag_ch::before{background-position:0 -697px}.bw-flag_th::before{background-position:0 -720px}.bw-flag_us::before{background-position:0 -787px}.bw-flag_ae::before{background-position:0 -765px}.bw-flag_gb::before{background-position:0 -742px}.bw-flag_vn::before{background-position:0 -810px}.bw-flag_ie::before{background-position:0 -832px}.bw-flag_cy::before{background-position:0 -854px}.bw-flag_gr::before{background-position:0 -877px}.bw-flag_is::before{background-position:0 -900px}.bw-flag_id::before{background-position:0 -968px}.bw-flag_mt::before{background-position:0 -923px}.bw-flag_nz::before{background-position:0 -990px}.bw-flag_tr::before{background-position:0 -945px}.bw-flag_al::before{background-position:0 -1035px}.bw-flag_rs::before{background-position:0 -1057px}.bw-flag_bg::before{background-position:0 -1080px}.bw-flag_pr::before{background-position:0 -1102px}.bw-flag_mm::before{background-position:0 -1125px}.bw-flag_kh::before{background-position:0 -1147px}.bw-flag_by::before{background-position:0 -1170px}.bw-flag_ph::before{background-position:0 -1192px}.bw-flag_np::before{background-position:0 -1215px}.bw-flag_ua::before{background-position:0 -1260px}.bw-flag_ir::before{background-position:0 -1282px}.bw-flag_za::before{background-position:0 -1305px}.bw-flag_lk::before{background-position:0 -1327px}.bw-flag_ro::before{background-position:0 -1350px}.bw-flag_my::before{background-position:0 -1372px}.bw-flag_mx::before{background-position:0 -1395px}.bw-flag_iq::before{background-position:0 -1418px}.bw-flag_ug::before{background-position:0 -1441px}.bw-flag_dj::before{background-position:0 -1464px}.bw-flag_pk::before{background-position:0 -1487px}.bw-flag_tz::before{background-position:0 -1510px}.bw-flag_rw::before{background-position:0 -1533px}.bw-flag_ke::before{background-position:0 -1556px}.bw-flag_so::before{background-position:0 -1579px}.bw-flag_mz::before{background-position:0 -1602px}.bw-flag_om::before{background-position:0 -1625px}.bw-flag_qa::before{background-position:0 -1647px}.bw-flagSmall{margin-right:-4px}.bw-flagSmall::before{transform:scale(0.7222222222);transform-origin:left center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagIcon": "bw-flagIcon",
	"flag_au": "bw-flag_au",
	"flag_at": "bw-flag_at",
	"flag_be": "bw-flag_be",
	"flag_ca": "bw-flag_ca",
	"flag_cn": "bw-flag_cn",
	"flag_hr": "bw-flag_hr",
	"flag_cz": "bw-flag_cz",
	"flag_dk": "bw-flag_dk",
	"flag_ee": "bw-flag_ee",
	"flag_fi": "bw-flag_fi",
	"flag_fr": "bw-flag_fr",
	"flag_de": "bw-flag_de",
	"flag_int": "bw-flag_int",
	"flag_hk": "bw-flag_hk",
	"flag_hu": "bw-flag_hu",
	"flag_in": "bw-flag_in",
	"flag_il": "bw-flag_il",
	"flag_it": "bw-flag_it",
	"flag_jp": "bw-flag_jp",
	"flag_kr": "bw-flag_kr",
	"flag_lv": "bw-flag_lv",
	"flag_lt": "bw-flag_lt",
	"flag_nl": "bw-flag_nl",
	"flag_no": "bw-flag_no",
	"flag_pl": "bw-flag_pl",
	"flag_pt": "bw-flag_pt",
	"flag_ru": "bw-flag_ru",
	"flag_sg": "bw-flag_sg",
	"flag_si": "bw-flag_si",
	"flag_es": "bw-flag_es",
	"flag_se": "bw-flag_se",
	"flag_ch": "bw-flag_ch",
	"flag_th": "bw-flag_th",
	"flag_us": "bw-flag_us",
	"flag_ae": "bw-flag_ae",
	"flag_gb": "bw-flag_gb",
	"flag_vn": "bw-flag_vn",
	"flag_ie": "bw-flag_ie",
	"flag_cy": "bw-flag_cy",
	"flag_gr": "bw-flag_gr",
	"flag_is": "bw-flag_is",
	"flag_id": "bw-flag_id",
	"flag_mt": "bw-flag_mt",
	"flag_nz": "bw-flag_nz",
	"flag_tr": "bw-flag_tr",
	"flag_al": "bw-flag_al",
	"flag_rs": "bw-flag_rs",
	"flag_bg": "bw-flag_bg",
	"flag_pr": "bw-flag_pr",
	"flag_mm": "bw-flag_mm",
	"flag_kh": "bw-flag_kh",
	"flag_by": "bw-flag_by",
	"flag_ph": "bw-flag_ph",
	"flag_np": "bw-flag_np",
	"flag_ua": "bw-flag_ua",
	"flag_ir": "bw-flag_ir",
	"flag_za": "bw-flag_za",
	"flag_lk": "bw-flag_lk",
	"flag_ro": "bw-flag_ro",
	"flag_my": "bw-flag_my",
	"flag_mx": "bw-flag_mx",
	"flag_iq": "bw-flag_iq",
	"flag_ug": "bw-flag_ug",
	"flag_dj": "bw-flag_dj",
	"flag_pk": "bw-flag_pk",
	"flag_tz": "bw-flag_tz",
	"flag_rw": "bw-flag_rw",
	"flag_ke": "bw-flag_ke",
	"flag_so": "bw-flag_so",
	"flag_mz": "bw-flag_mz",
	"flag_om": "bw-flag_om",
	"flag_qa": "bw-flag_qa",
	"flagSmall": "bw-flagSmall"
};
module.exports = ___CSS_LOADER_EXPORT___;
